import { render } from "./TestigosComponent.vue?vue&type=template&id=1361051e"
import script from "./TestigosComponent.vue?vue&type=script&lang=js"
export * from "./TestigosComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__